module.exports = __webpack_public_path__ + "static/img/kunyaojituan.33d7bc0f.png";